import {
  Accordion,
  Badge,
  Box,
  Button,
  Center,
  Checkbox,
  Grid,
  Group,
  ScrollArea,
  Skeleton,
  Text,
  Title,
  useMantineTheme,
} from "@mantine/core";
import { memo, useCallback, useEffect, useState } from "react";

import { areEqual, FixedSizeGrid } from "react-window";
import ReactVirtualizedAutoSizer from "react-virtualized-auto-sizer";
import {
  IconCamera,
  IconCategory,
  IconChecklist,
  IconSubtask,
} from "@tabler/icons-react";
import { CaptureThumb } from "core/components/index";
import DivButton from "core/components/divButton/DivButton";
import { logger } from "utils/logger";
import { pluralize } from "utils/helper";
import { CaptureEventType } from "core/components/capture/CaptureThumb";
import { CountDisplay } from "core/components/countDisplay/CountDisplay";
import _ from "lodash";
import { StyleAssetThumb } from "./StyleAssetThumb";
import classes from './StyleMediaGridLayout.module.scss';

const StyleMediaGridLayout = ({
  displaySettings,
  onImageEvent,
  thumbnailSize = 300,
  captures = [],
  selectedItems,
  selectedGroups,
  onGroupSelect,
  onCaptureChange,
  showLoading,
  filter,
  selectedStyle,
  showMeta=true,
  fit="cover",
  user
}) => {
  // const imageHash = useRef({})
  const [selectedAccorian, setSelectedAccordian] = useState([]);
  const theme = useMantineTheme();

  logger.log(captures, "CAPTURES");

  const isSelected = useCallback((val, selectedItems) => {
    let selected = false;
    if (selectedItems && val) {
      selected = selectedItems.find((item) => val.id === item.id)
        ? true
        : false;
    }
    return selected;
  }, []);

  useEffect(() => {
    if (selectedAccorian.length === 0) {
      setSelectedAccordian(captures.map((val, idx) => idx.toString()));
    }
  }, [filter]);

  const ProxyCell = memo((props) => {
    const { columnIndex, rowIndex, style } = props;

    const ThumbCallback = useCallback(
      ({ columnIndex, data, rowIndex, style }) => {
        return (
          <div style={{ height: "100%", width: "100%", padding: 5 }}>
            <Box sx={{ width: "100%", height: "100%" }}>
              <Skeleton width={"100%"} height={"80%"} />
              <Skeleton height={8} mt={10} radius="xl" />
              <Skeleton height={8} mt={5} width="70%" radius="xl" />
            </Box>
          </div>
        );
      },
      []
    );

    const tmpStyle = { ...style };
    return (
      <div key={`${columnIndex}-${rowIndex}`} style={tmpStyle}>
        <ThumbCallback {...props} />
      </div>
    );
  }, areEqual);

  const Cell = memo(
    (props) => {
      const { columnIndex, data, rowIndex, style } = props;
      const idx = columnIndex + rowIndex * data.colCount;
      var val = captures[idx];

      logger.log(captures, idx, val);
      if (!data.colCount) {
        val = captures.find((val) => val.id === data.id);
        val = val.original;
      } else if (val) {
        val = val;
      }

      const ThumbCallback = useCallback(
        ({ columnIndex, data, rowIndex, style }) => {
          var imageURL = data && data.preview ? data.preview : "";

          return (
            <div
              style={{
                height: "100%",
                width: "100%",
                paddingLeft: 10,
                paddingRight: 10,
              }}
            >
              {data ? (
                <StyleAssetThumb
                  shot={{ ...data, ...selectedStyle, id: data.id, styleNumber: data.styles, dept: data.department }}
                  size={thumbnailSize}
                  src={imageURL}
                  onImageEvent={onImageEvent}
                  tags={data.tags}
                  onCaptureChange={onCaptureChange}
                  selectedItems={selectedItems}
                  user={user}

                />
              ) : (
                // <CaptureThumb

                //     resolvePath={false}
                //     showPsdLoaded={true}
                //     showSettings={false}
                //     src={imageURL}
                //     image={data}
                //     onImageEvent={onImageEvent}
                //     size={thumbnailSize}
                //     selected={isSelected(val, selectedItems)}
                //     onCaptureChange={(type, value) => onCaptureChange(type, value, [data])}
                // />
                <div></div>
              )}
            </div>
          );
        },
        [val]
      );

      const tmpStyle = { ...style };
      return (
        <div key={`${columnIndex}-${rowIndex}`} style={tmpStyle}>
          <ThumbCallback {...props} data={val} />
        </div>
      );
    },

    areEqual
  );
  const getLayout_table = () => {
    return (
      <Grid>
        {captures.map((val, idx) => {
          return (
            <Grid.Col key={idx} md={6} lg={2}>
              <Cell data={val} style={{ height: "100%", width: "100%" }} />
            </Grid.Col>
          );
        })}
      </Grid>
    );
  };

  function AccordionLabel(props) {
    const { original, onAction } = props;
    var notifyDisplay;
    if (filter.groupBy && filter.groupBy === "styles") {
      // grab the style
      const style = style.samples.find(
        (val) => val.stylenumber === original.name
      );
      if (style && style.taskCount) {
        // notifyDisplay = <Badge>{style.taskCount} {pluralize('Task',parseInt(style.taskCount))} Created</Badge>
        notifyDisplay = (
          <Group>
            <CountDisplay
              theme={theme}
              val={style.taskCount}
              icon={<IconSubtask size={18} strokeWidth={1} />}
              tooltip={"Total Tasks"}
            />
            <CountDisplay
              theme={theme}
              val={style.taskCompleteCount}
              icon={<IconChecklist size={18} strokeWidth={1} />}
              tooltip={"Total Tasks"}
            />
          </Group>
        );
      }
    }
    var isChecked = false;
    var indeterminate = false;
    if (original.subRows) {
      // if all of the subrows are included in the selected items.`
      const commonItems = _.intersectionBy(
        original.subRows,
        selectedItems,
        "id"
      );
      isChecked = commonItems.length === original.subRows.length;
      indeterminate =
        commonItems.length && commonItems.length < original.subRows.length
          ? true
          : false;
    }
    return (
      <Group wrap="nowrap" grow>
        <Group position="apart">
          <Group wrap="nowrap">
            <Checkbox
              indeterminate={indeterminate}
              checked={isChecked}
              // checked={selectedGroups.find((val) => val.id === original.id) ? true : false}
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
              }}
              onChange={(e) => {
                onGroupSelect(e, original, e.currentTarget.checked);
              }}
            ></Checkbox>
            <IconCategory stroke={1} />
            <Group spacing={0} wrap="nowrap">
              <Title color={original.name ? "" : "dimmed"} order={6}>
                {original.name ? original.name : "No Value"}
              </Title>
              {original.subRows &&
              original.subRows.length &&
              original.photoCode ? (
                <Group spacing={0} wrap="nowrap" style={{ maxWidth: 450 }}>
                  <Title color={original.name ? "" : "dimmed"} order={6}>
                    &nbsp;/&nbsp;{original.photoCode}
                  </Title>

                  <Text
                    title={original.styleName}
                    truncate
                    size={"xs"}
                    c={original.name ? "" : "dimmed"}
                  >
                    &nbsp; - {original.styleName}
                  </Text>
                </Group>
              ) : null}
            </Group>
          </Group>
          {/* <Badge variant="gradient" gradient={{ from: '#ed6ea0', to: '#ec8c69', deg: 35 }}>{shots.length} Shots</Badge> */}
          <Group>
            <Badge>
              {original.subRows && original.subRows.length
                ? original.subRows.length
                : 0}{" "}
              {pluralize("Shot", original.subRows?.length)}
            </Badge>
            {/* 
                      {editMapRef.current[id] ? (
                          <Group>
                              <DivButton
                                  color='brand'
                                  onClick={(e) => {
                                      e.preventDefault();
                                      e.stopPropagation();
                                      onAction(GuideActions.ADD_GUIDE_CAT_SHOT, props);
                                  }}>
                                  Add Shot
                              </DivButton>
                          </Group>
                      ) : null} */}

            <Group>
              {/* <DivButton
                              color='red'
                              variant='light'
                              onClick={(e) => {
                                  e.preventDefault();
                                  e.stopPropagation();
                                  // onAction(GuideActions.REMOVE_GUIDE_CAT, props);
                              }}>
                              Delete
                          </DivButton> */}
              {notifyDisplay ? notifyDisplay : null}
              <DivButton
                color="brand"
                variant="outline"
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  onAction("createTask", props);
                }}
              >
                Create Task
              </DivButton>
            </Group>
          </Group>
        </Group>
      </Group>
    );
  }

  const onCreateTaskClick = (value, type) => {
    logger.log(value, type);
    onImageEvent(CaptureEventType.CREATE_TASK, value.originalSubRows);
  };


  const items = captures?.map((item, idx) => {
    return (
      <Accordion.Item value={idx.toString()} key={idx}>
        <Accordion.Control onClick={(e) => e.stopPropagation()}>
          <AccordionLabel
            {...item}
            onAction={(type, value) => onCreateTaskClick(value, type)}
          />
        </Accordion.Control>
        <Accordion.Panel>
          <Box>
            {item?.subRows?.length ? (
              // <Grid>
              <Group>
                {item.subRows.map((tmpVal, idx) => {
                  const val = tmpVal.original;
                  var imageURL = val && val.loURL ? val.loURL : "";

                  return (
                    <div key={idx} md={6} lg={2}>
                      <div style={{ height: "100%", width: "100%" }}>
                        <CaptureThumb
                          showPsdLoaded={true}
                          showSettings={true}
                          src={imageURL}
                          image={val}
                          onImageEvent={onImageEvent}
                          size={thumbnailSize}
                          selected={isSelected(val, selectedItems)}
                          onCaptureChange={(type, value) =>
                            onCaptureChange(type, value, [val])
                          }
                        />
                      </div>
                    </div>
                  );
                })}
              </Group>
            ) : (
              <EmptyState />
            )}

            {/* <CategoryEdit onChange={onCategoryChange} value={item} editable={editMapRef.current[item.id] ? true : false} onCancel={closeAllModals} showActionBar={false} /> */}
            {/* <GuideCategory category={item} editable={true} fullscreen={true} editableShots={false} /> */}
            {/* <Category value={item} classes={classes} onEditClick={onEditCateogryClick}/> */}
          </Box>
        </Accordion.Panel>
      </Accordion.Item>
    );
  });

  const getLayout2 = () => {
    return (
      <ReactVirtualizedAutoSizer>
        {({ height, width }) => {
          const colWidth = thumbnailSize < 180 ? 190 : thumbnailSize + 10;
          const rowHeight = thumbnailSize < 180 ? 260 : thumbnailSize + 400;

          let colCount = Math.floor(width / colWidth);
          let rowCount = showLoading
            ? 4
            : Math.floor(captures.length / colCount);

          if ((captures.length / colCount) % 2) {
            ++rowCount;
            // ++colCount;
          }
          //rowCount = (captures.length/colCount)%2?rowCount+1:rowCount;
          let layout;

          logger.log(filter, rowCount, rowHeight);

          if (filter.groupBy && filter.groupBy.length) {
            layout = (
              <ScrollArea
                sx={{
                  height: height,
                  width: width + theme.spacing.xl,
                  overflow: "hidden",
                  paddingRight: theme.spacing.xl,
                }}
              >
                <Accordion
                  multiple={true}
                  sx={{ width: "100%" }}
                  chevronPosition="right"
                  variant="contained"
                  value={selectedAccorian}
                  onChange={setSelectedAccordian}
                >
                  {items}
                </Accordion>
              </ScrollArea>
            );
          } else {
            layout = (
              <FixedSizeGrid
                columnCount={colCount}
                columnWidth={width / colCount}
                height={height}
                rowCount={rowCount}
                rowHeight={rowHeight}
                width={width + 4}
                itemData={{ colCount, rowCount }}
              >
                {Cell}
              </FixedSizeGrid>
            );
          }

          return (
            <>
              {showLoading ? (
                <FixedSizeGrid
                  columnCount={colCount}
                  columnWidth={width / colCount}
                  height={height}
                  rowCount={rowCount}
                  rowHeight={rowHeight}
                  width={width}
                  itemData={{ colCount, rowCount }}
                >
                  {ProxyCell}
                </FixedSizeGrid>
              ) : (
                <div style={{ height: "100%" }}>{layout}</div>
              )}
            </>
          );
        }}
      </ReactVirtualizedAutoSizer>
    );
  };

  const getLayout3 = () => {
    return (
      <ReactVirtualizedAutoSizer>
        {({ height, width }) => {
          const colWidth = thumbnailSize < 180 ? 190 : thumbnailSize + 10;
          const rowHeight = thumbnailSize < 180 ? 260 : thumbnailSize + 400;

          let colCount = Math.floor(width / colWidth);
          let rowCount = showLoading
            ? 4
            : Math.floor(captures.length / colCount);

          if ((captures.length / colCount) % 2) {
            ++rowCount;
            // ++colCount;
          }
          //rowCount = (captures.length/colCount)%2?rowCount+1:rowCount;
          let layout;

          logger.log(filter, rowCount, rowHeight);

          if (filter.groupBy && filter.groupBy.length) {
            layout = (
              <ScrollArea
                sx={{
                  height: height,
                  width: width + theme.spacing.xl,
                  overflow: "hidden",
                  paddingRight: theme.spacing.xl,
                }}
              >
                <Accordion
                  multiple={true}
                  sx={{ width: "100%" }}
                  chevronPosition="right"
                  variant="contained"
                  value={selectedAccorian}
                  onChange={setSelectedAccordian}
                >
                  {items}
                </Accordion>
              </ScrollArea>
            );
          } else {
            layout = (
              <FixedSizeGrid
                columnCount={colCount}
                columnWidth={width / colCount}
                height={height}
                rowCount={rowCount}
                rowHeight={rowHeight}
                width={width + 4}
                itemData={{ colCount, rowCount }}
              >
                {Cell}
              </FixedSizeGrid>
            );
          }

          return (
            <>
              {showLoading ? (
                <FixedSizeGrid
                  columnCount={colCount}
                  columnWidth={width / colCount}
                  height={height}
                  rowCount={rowCount}
                  rowHeight={rowHeight}
                  width={width}
                  itemData={{ colCount, rowCount }}
                >
                  {ProxyCell}
                </FixedSizeGrid>
              ) : (
                <div style={{ height: "100%" }}>{layout}</div>
              )}
            </>
          );
        }}
      </ReactVirtualizedAutoSizer>
    );
  };

  const getLayout = () => {
    return (
      <Group gap={"md"} wrap="wrap" align="start">
        {showLoading ? (
          [1, 2, 3, 4, 5].map((val) => {
            return (<div style={{ height: 500, width: 300, padding: 5 }}>
              <Box style={{ width: "100%", height: "100%" }}>
                <Skeleton width={"100%"} height={"80%"} />
                <Skeleton height={8} mt={10} radius="xl" />
                <Skeleton height={8} mt={5} width="70%" radius="xl" />
              </Box>
            </div>);
          })
        ) : (
          <>
            {captures.map((val, idx) => {
              // check logger.l
              // logger.log(thumbnailSize, val);
              var imageURL = val && val.loURL ? val.loURL : "";
              if(thumbnailSize >= 300){
                var imageURL = val && val.midURL ? val.midURL : "";
              }else{
                var imageURL = val && val.loURL ? val.loURL : "";
              }
             
              return (
                <div key={idx} className={classes.renderer} style={{ height: "100%", width: `${thumbnailSize}px`}}>
                  {val ? (
                    <StyleAssetThumb
                      shot={{ ...val, ...selectedStyle, id: val.id, styleNumber: selectedStyle.stylenumber, dept: selectedStyle.department }}
                      size={thumbnailSize}
                      src={imageURL}
                      onImageEvent={onImageEvent}
                      tags={val.tags}
                      fit={fit}
                      showMetaInfo={showMeta}
                      onCaptureChange={onCaptureChange}
                      selectedItems={selectedItems}
                      user={user}
                    />
                  ) : (
                    <div></div>
                  )}
                </div>
              );
            })}
          </>
        )}
      </Group>
    );
  };

  const content =
    !showLoading && captures.length === 0 ? <EmptyState /> : getLayout();

  return (
    // <Group spacing={'lg'}>

    //     {captures.map((val,idx) => (
    //         <ImageThumb key={idx} image={val} onImageEvent={onImageEvent} size={thumbnailSize} selected={isSelected(val,selectedItems)} />
    //     ))}

    // </Group>
    <Box
      style={(theme) => ({
        width: "100%",
        // height: "100vh",
        // marginRight: -theme.spacing.lg,
        marginRight: 0,
        marginLeft: 0,
        paddingBottom: 100,
        // paddingLeft: 21,
        // paddingRight: 21,
      })}
    >
      {content}
    </Box>
  );
};

export default StyleMediaGridLayout;

const EmptyState = () => {
  const theme = useMantineTheme();
  
  return (
    <Center style={{ height: "100%", minHeight: "400px" }}>
      <Box style={{ textAlign: "center", maxWidth: "400px", padding: theme.spacing.xl }}>
        {/* Icon with gradient background */}
        <Box
          className={classes.emptyIcon}
          style={{
            // width: 80,
            // height: 80,
            // borderRadius: "50%",
            // background: theme.colorScheme === 'dark' ? `linear-gradient(135deg, ${theme.colors.dark[8]} 0%, ${theme.colors.dark[8]} 100%)` : `linear-gradient(135deg, ${theme.colors.gray[1]} 0%, ${theme.colors.gray[1]} 100%)`,
            // display: "flex",
            // alignItems: "center",
            // justifyContent: "center",
            // margin: "0 auto 24px auto",
            // border: `2px solid ${theme.colors.dark[7]}`,
          }}
        >
          <IconCamera 
            size={36} 
            stroke={1.5} 
            color={theme.colorScheme === 'dark' ? theme.colors.dark[5] : theme.colors.gray[5]}
          />
        </Box>

        {/* Main heading */}
        <Title 
          order={3}
          c={"dimmed"}
          mb={theme.spacing.sm}
          fw={600}
        
        >
          No Captures Available
        </Title>

        {/* Subtitle */}
        <Text 
          size="sm" 
          style={{ 
            color: theme.colors.gray[6],
            lineHeight: 1.5,
            marginBottom: theme.spacing.lg,
          }}
        >
          There are no captures to display for the current style. 
          Try adjusting your filters or check back later for new content.
        </Text>

        {/* Action suggestions */}
        {/* if there is a filter, show the clear filters button */}
        
        {/* <Group spacing="xs" justify="center">
          <Button
            variant="light" 
            onClick={onClearFilterClick}
            size="sm"
            style={{ cursor: "default" }}
          >
            Clear Filters
          </Button>
          
        </Group> */}
        
      </Box>
    </Center>
  );
};
